import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Separator.css';

const propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['standard', 'narrow', 'wide', 'huge']),
};

export class Separator extends React.Component {
    static defaultProps = {
        className: undefined,
        type: 'standard',
    };

    render() {
        return <div className={classNames(s.separator, s[this.props.type], this.props.className)} />;
    }
}

Separator.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/containers/Separator.jsx